import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import sidebarCloseIcon from "assets/images/journeys/sidebar-close.svg";

import { ToggleSidebarAction } from "Redux/Global/action";

import {
  Wrapper,
  Content,
  Head,
  Title,
  Toggler,

  // Hr,
  List,
} from "./styled";

const Sidebar = ({ title, toggleTooltip, secondary, withoutToggle, children, onToggle, CustomWidth, active }) => {
  const dispatch = useDispatch();

  const { toggledSidebar } = useSelector((state) => state.globalReducer);

  // Listen for changes in toggledSidebar and trigger a resize event
  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300); // Match the CSS transition duration
  }, [toggledSidebar]);

  const onTogglerClickHandle = () => {
    if (!!onToggle) {
      onToggle();
    } else {
      dispatch(ToggleSidebarAction(toggledSidebar === "left" ? "" : "left"));
    }
  };

  const isActive = active == 0 ? false : toggledSidebar === "left";

  return (
    <Wrapper $width={CustomWidth} $active={isActive}>
      <Content>
        <Head>
          <Title>{title}</Title>
          {!withoutToggle && (
            <Toggler type="button" title={toggleTooltip?.[isActive] || ''} onClick={onTogglerClickHandle}>
              <img src={sidebarCloseIcon} alt="" />
            </Toggler>
          )}
        </Head>

        <List $secondary={secondary}>{children}</List>
      </Content>
    </Wrapper>
  );
};

Sidebar.propTypes = {
  title: PropTypes.string.isRequired,
  secondary: PropTypes.bool,
  withoutToggle: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default Sidebar;
